




import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { Component } from '@niknevis/vue-modules'
import { TicketStatus } from '@/modules/ticket/models/ticket-resource.model'

@Component
export default class TicketStatusView extends Vue {
  @Prop({ required: true }) status: TicketStatus
  @Prop({ required: true }) statuses!: { [key in TicketStatus]: string }
  @Prop({ default: false }) dark: boolean

  get statusColor() {
    switch (this.status) {
      case TicketStatus.NEW:
        return 'text-tes-green'
      case TicketStatus.CLOSED:
        return 'text-tes-red-light'
      case TicketStatus.AGENT_CREATED:
        return 'text-tes-navy-blue'
      case TicketStatus.PENDING:
        return this.dark ? 'text-yellow' : 'text-amber-7'
      case TicketStatus.COSTUMER_RESPONSE:
        return 'text-tes-blue'
      case TicketStatus.AGENT_RESPONSE:
        return 'text-tes-blue'
      case TicketStatus.PENDING_RESPONSE:
        return this.dark ? 'text-yellow' : 'text-amber-7'
      default:
        return ''
    }
  }
}
